class Monitoring.Models.Taxonomy extends Backbone.Model
  urlRoot: '/keepcon/settings/account_setting/taxonomies'

  defaults:
    name: ''
    code: ''
    hierarchy: ''
    active: false

  validateFields: ->
    isValid = true
    $.ajax
      url: "/keepcon/settings/account_setting/validate_hierarchy",
      async: false,
      type: "POST",
      data: {hierarchy: @get('hierarchy')}
      success: (response) =>
        if response.errors.length > 0
          showError(response.errors)
          isValid = false
      error: (response) =>
        showError(response.errors)
        isValid = false
    if isValid and (@get('code').indexOf(' ') != -1)
      showError(I18n.t('monitoring.taxonomy.invalid_code_field'))
      isValid = false
    isValid

class Monitoring.Collections.TaxonomiesCollection extends Backbone.Collection
  model: Monitoring.Models.Taxonomy
  url: '/keepcon/settings/account_setting/taxonomies'
